module.exports = __webpack_public_path__ + "img/2.540a43c2.jpg";